<!-- @format -->

<template>
    <div>
        <DataLoading
            v-if="loading && !events.length"
            class="mt-5 mb-5 pt-5 pb-5" />
        <template v-else>
            <div v-if="!noData">
                <v-list class="gst-list pt-0">
                    <v-list-item
                        v-for="(event, index) in events"
                        :key="index"
                        class="gst-list__item px-0 py-4"
                        :class="{
                            'py-2': !expandableCard,
                            'py-1': expandableCard,
                        }"
                        :to="!expandableCard ? eventRoute(event.id) : null">
                        <EventsSearchByItem
                            :with-price-icon="true"
                            :event="event"
                            :is-loyalty-currency-type-money="isLoyaltyCurrencyTypeMoney"
                            class="u-background-transparent u-width-100" />
                    </v-list-item>
                </v-list>
                <GhostButton
                    v-if="!isAllItemsLoaded"
                    :data-test-id="$testId('buttons.seeMore')"
                    class="mx-auto d-flex mt-4"
                    :loading="loading"
                    @click="loadNextPage()">
                    {{ $t('_common:buttons.showMore') }}
                    <BaseIcon
                        symbol-id="icons--dropdown_arrow"
                        class="u-mouse-pointer ml-2" />
                </GhostButton>
            </div>
            <div
                v-else
                class="d-flex justify-center">
                <slot
                    v-if="$slots['empty-list']"
                    name="empty-list"></slot>
                <SearchResultNoData v-else>
                    {{ $t('messages.noData') }}
                </SearchResultNoData>
            </div>
        </template>
    </div>
</template>
<script>
import debounce from 'lodash/debounce';
import { mapActions, mapState, mapGetters } from 'vuex';
import SearchResultNoData from '@core/shared/components/search/common/SearchResultNoData.vue';
import DataLoading from '@core/shared/components/loading/DataLoading.vue';
import { buildEventRouteObject } from '@tenant/app/utils/searchUtils';
import GhostButton from '@tenant/app/components/buttons/GhostButton';
import EventsSearchByItem from '@tenant/app/components/event/EventsSearchByItem.vue';

const STORE_NAME = 'events';

export default {
    name: 'EventsSearchBy',
    components: {
        DataLoading,
        EventsSearchByItem,
        SearchResultNoData,
        GhostButton,
    },
    i18nOptions: {
        namespaces: 'shared',
        keyPrefix: 'components.search.eventsSearchBy',
    },
    testIdOptions: {
        keyPrefix: 'search.eventsTab',
    },
    props: {
        search: {
            type: Object,
            required: true,
        },
        withUserAnalytics: {
            type: Boolean,
            default: false,
        },
        expandableCard: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            searchState: (state) => state.searchState.current,
            events: (state) => state[STORE_NAME].list,
            loading: (state) => state[STORE_NAME].loading,
        }),
        ...mapGetters({
            isAllItemsLoaded: `${STORE_NAME}/isAllItemsLoaded`,
            isLoyaltyCurrencyTypeMoney: 'appTenant/isLoyaltyCurrencyTypeMoney',
        }),
        noData() {
            return !this.events.length;
        },
        searchParam() {
            return {
                limit: 6,
                ...this.search,
            };
        },
    },
    watch: {
        search: {
            handler: function () {
                this.loadDataDebouced();
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions({
            get: `${STORE_NAME}/get`,
        }),
        loadNextPage() {
            this.get({
                refresh: false,
                loadNextPage: true,
                search: this.searchParam,
                userAnalytics: this.withUserAnalytics,
            });
        },
        loadDataDebouced: debounce(function () {
            this.load();
        }, 500),
        load() {
            this.get({
                refresh: true,
                loadNextPage: false,
                search: { ...this.searchParam, count: true },
            });
        },
        eventRoute(eventId) {
            return buildEventRouteObject(eventId);
        },
    },
    mounted() {
        this.load();
    },
};
</script>
